import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListagemComposicao from "components/Relatorio/RelatorioComposicaoContas/ListagemComposicao";
import { OperacaoEnum } from "resources/enums/conta";

function RelatorioComposicaoReceitasPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Relatório de receitas com composição",
      url: "/relatorios/financeiro/composicao-receitas",
    },
  ]);

  return (
    <Container>
      <ListagemComposicao operacao={OperacaoEnum.Receita} />
    </Container>
  );
}

export default RelatorioComposicaoReceitasPage;
